/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { CoreBaseService } from '../core-base-service';
import { CoreApiConfiguration } from '../core-api-configuration';
import { CoreStrictHttpResponse } from '../core-strict-http-response';

import { documentsControllerGenerateDownloadUrl } from '../fn/documents/documents-controller-generate-download-url';
import { DocumentsControllerGenerateDownloadUrl$Params } from '../fn/documents/documents-controller-generate-download-url';
import { documentsControllerGenerateProjectDownloadUrl } from '../fn/documents/documents-controller-generate-project-download-url';
import { DocumentsControllerGenerateProjectDownloadUrl$Params } from '../fn/documents/documents-controller-generate-project-download-url';
import { documentsControllerGenerateProjectUploadUrls } from '../fn/documents/documents-controller-generate-project-upload-urls';
import { DocumentsControllerGenerateProjectUploadUrls$Params } from '../fn/documents/documents-controller-generate-project-upload-urls';
import { documentsControllerGenerateUploadUrls } from '../fn/documents/documents-controller-generate-upload-urls';
import { DocumentsControllerGenerateUploadUrls$Params } from '../fn/documents/documents-controller-generate-upload-urls';
import { CorePresignedDownloadUrlResponseDto } from '../models/core-presigned-download-url-response-dto';
import { CorePresignedUploadResponseDto } from '../models/core-presigned-upload-response-dto';

@Injectable({ providedIn: 'root' })
export class CoreDocumentsService extends CoreBaseService {
  constructor(config: CoreApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `documentsControllerGenerateUploadUrls()` */
  static readonly DocumentsControllerGenerateUploadUrlsPath = '/o2-core/documents/{tenant}/subtask-attachments/upload-url';

  /**
   * Generate presigned URLs for subtask attachment upload.
   *
   * Creates presigned POST URLs with embedded minimal metadata for S3 upload. URLs expire after 180 seconds. Client must POST with all returned fields. Supports batch upload for multiple files.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsControllerGenerateUploadUrls()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentsControllerGenerateUploadUrls$Response(params: DocumentsControllerGenerateUploadUrls$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<Array<CorePresignedUploadResponseDto>>> {
    const obs = documentsControllerGenerateUploadUrls(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Generate presigned URLs for subtask attachment upload.
   *
   * Creates presigned POST URLs with embedded minimal metadata for S3 upload. URLs expire after 180 seconds. Client must POST with all returned fields. Supports batch upload for multiple files.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsControllerGenerateUploadUrls$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentsControllerGenerateUploadUrls(params: DocumentsControllerGenerateUploadUrls$Params, context?: HttpContext): Observable<Array<CorePresignedUploadResponseDto>> {
    const resp = this.documentsControllerGenerateUploadUrls$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<Array<CorePresignedUploadResponseDto>>): Array<CorePresignedUploadResponseDto> => r.body)
    );
  }

  /** Path part for operation `documentsControllerGenerateDownloadUrl()` */
  static readonly DocumentsControllerGenerateDownloadUrlPath = '/o2-core/documents/{tenant}/subtask-attachments/download-url';

  /**
   * Generate presigned URL for subtask attachment download.
   *
   * Creates a presigned GET URL for downloading a subtask attachment from S3. URL expires after 180 seconds. Validates S3 key prefix and tenant isolation.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsControllerGenerateDownloadUrl()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentsControllerGenerateDownloadUrl$Response(params: DocumentsControllerGenerateDownloadUrl$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CorePresignedDownloadUrlResponseDto>> {
    const obs = documentsControllerGenerateDownloadUrl(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Generate presigned URL for subtask attachment download.
   *
   * Creates a presigned GET URL for downloading a subtask attachment from S3. URL expires after 180 seconds. Validates S3 key prefix and tenant isolation.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsControllerGenerateDownloadUrl$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentsControllerGenerateDownloadUrl(params: DocumentsControllerGenerateDownloadUrl$Params, context?: HttpContext): Observable<CorePresignedDownloadUrlResponseDto> {
    const resp = this.documentsControllerGenerateDownloadUrl$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<CorePresignedDownloadUrlResponseDto>): CorePresignedDownloadUrlResponseDto => r.body)
    );
  }

  /** Path part for operation `documentsControllerGenerateProjectUploadUrls()` */
  static readonly DocumentsControllerGenerateProjectUploadUrlsPath = '/o2-core/documents/{tenant}/project-attachments/upload-url';

  /**
   * Generate presigned URLs for project attachment upload.
   *
   * Creates presigned POST URLs with embedded minimal metadata for S3 upload. URLs expire after 180 seconds. Client must POST with all returned fields. Supports batch upload for multiple files.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsControllerGenerateProjectUploadUrls()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentsControllerGenerateProjectUploadUrls$Response(params: DocumentsControllerGenerateProjectUploadUrls$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<Array<CorePresignedUploadResponseDto>>> {
    const obs = documentsControllerGenerateProjectUploadUrls(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Generate presigned URLs for project attachment upload.
   *
   * Creates presigned POST URLs with embedded minimal metadata for S3 upload. URLs expire after 180 seconds. Client must POST with all returned fields. Supports batch upload for multiple files.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsControllerGenerateProjectUploadUrls$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentsControllerGenerateProjectUploadUrls(params: DocumentsControllerGenerateProjectUploadUrls$Params, context?: HttpContext): Observable<Array<CorePresignedUploadResponseDto>> {
    const resp = this.documentsControllerGenerateProjectUploadUrls$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<Array<CorePresignedUploadResponseDto>>): Array<CorePresignedUploadResponseDto> => r.body)
    );
  }

  /** Path part for operation `documentsControllerGenerateProjectDownloadUrl()` */
  static readonly DocumentsControllerGenerateProjectDownloadUrlPath = '/o2-core/documents/{tenant}/project-attachments/download-url';

  /**
   * Generate presigned URL for project attachment download.
   *
   * Creates a presigned GET URL for downloading a project attachment from S3. URL expires after 180 seconds. Validates S3 key prefix and tenant isolation.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsControllerGenerateProjectDownloadUrl()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentsControllerGenerateProjectDownloadUrl$Response(params: DocumentsControllerGenerateProjectDownloadUrl$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CorePresignedDownloadUrlResponseDto>> {
    const obs = documentsControllerGenerateProjectDownloadUrl(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Generate presigned URL for project attachment download.
   *
   * Creates a presigned GET URL for downloading a project attachment from S3. URL expires after 180 seconds. Validates S3 key prefix and tenant isolation.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsControllerGenerateProjectDownloadUrl$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentsControllerGenerateProjectDownloadUrl(params: DocumentsControllerGenerateProjectDownloadUrl$Params, context?: HttpContext): Observable<CorePresignedDownloadUrlResponseDto> {
    const resp = this.documentsControllerGenerateProjectDownloadUrl$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<CorePresignedDownloadUrlResponseDto>): CorePresignedDownloadUrlResponseDto => r.body)
    );
  }

}
